/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const WhatsAppWebhookSetupObject = {
  AgentConnectorWhatsappWebhookSetup: "agent.connector.whatsapp_webhook_setup",
} as const;
export type WhatsAppWebhookSetupObject = ClosedEnum<
  typeof WhatsAppWebhookSetupObject
>;

export type WhatsAppWebhookSetup = {
  object: WhatsAppWebhookSetupObject;
  appId: string;
  callbackUrl: string;
  /**
   * Stable verification value for Meta's app-level Webhooks form. This is not a Meta API access token.
   */
  verifyToken: string;
};

/** @internal */
export const WhatsAppWebhookSetupObject$inboundSchema: z.ZodNativeEnum<
  typeof WhatsAppWebhookSetupObject
> = z.nativeEnum(WhatsAppWebhookSetupObject);
/** @internal */
export const WhatsAppWebhookSetupObject$outboundSchema: z.ZodNativeEnum<
  typeof WhatsAppWebhookSetupObject
> = WhatsAppWebhookSetupObject$inboundSchema;

/** @internal */
export const WhatsAppWebhookSetup$inboundSchema: z.ZodType<
  WhatsAppWebhookSetup,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: WhatsAppWebhookSetupObject$inboundSchema,
  app_id: z.string(),
  callback_url: z.string(),
  verify_token: z.string(),
}).transform((v) => {
  return remap$(v, {
    "app_id": "appId",
    "callback_url": "callbackUrl",
    "verify_token": "verifyToken",
  });
});
/** @internal */
export type WhatsAppWebhookSetup$Outbound = {
  object: string;
  app_id: string;
  callback_url: string;
  verify_token: string;
};

/** @internal */
export const WhatsAppWebhookSetup$outboundSchema: z.ZodType<
  WhatsAppWebhookSetup$Outbound,
  z.ZodTypeDef,
  WhatsAppWebhookSetup
> = z.object({
  object: WhatsAppWebhookSetupObject$outboundSchema,
  appId: z.string(),
  callbackUrl: z.string(),
  verifyToken: z.string(),
}).transform((v) => {
  return remap$(v, {
    appId: "app_id",
    callbackUrl: "callback_url",
    verifyToken: "verify_token",
  });
});

export function whatsAppWebhookSetupToJSON(
  whatsAppWebhookSetup: WhatsAppWebhookSetup,
): string {
  return JSON.stringify(
    WhatsAppWebhookSetup$outboundSchema.parse(whatsAppWebhookSetup),
  );
}
export function whatsAppWebhookSetupFromJSON(
  jsonString: string,
): SafeParseResult<WhatsAppWebhookSetup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WhatsAppWebhookSetup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WhatsAppWebhookSetup' from JSON`,
  );
}
